export const events = [
  { id: 1,  name: '4-DAY STANDARD TICKET' },
  { id: 2,  name: '4-DAY VIP TICKET' },
  { id: 3,  name: '1 DAY-STANDARD TICKET' },
  { id: 4,  name: '1-DAY VIP WEDNESDAY' },
  { id: 5,  name: '1-DAY VIP THURSDAY' },
  { id: 6,  name: '1-DAY VIP FRIDAY' },
  { id: 7,  name: '1-DAY VIP SATURDAY' },
  { id: 8,  name: '1-DAY WEDNESDAY' },
  { id: 9,  name: '1-DAY THURSDAY' },
  { id: 10, name: '1-DAY FRIDAY' },
  { id: 11, name: '1-DAY SATURDAY' },
  { id: 13, name: '4-DAY STANDARD TICKET (13)' },
  { id: 14, name: '4-DAY STANDARD TICKET (14)' },
  { id: 18, name: '4-DAY STANDARD TICKET (18)' },
  { id: 19, name: '4-DAY STANDARD TICKET (19)' },
  { id: 20, name: 'BEATS FOR LOVE WINTER - FRIDAY' },
  { id: 21, name: 'BEATS FOR LOVE WINTER - SATURDAY' },
  { id: 22, name: 'B4L WINTER - FRIDAY + SATURDAY' },
  { id: 23, name: 'Beats for Love Experience w/ KRYDER' },
  { id: 24, name: 'Beats for Love Experience w/ HYBRID MINDS' },
]

export const camps = [
  { id: 12, name: 'LOVE VILLAGE' },
  { id: 15, name: 'LOVE CAMP' },
  { id: 16, name: 'TENT VILLAGE' },
  { id: 17, name: 'CARAVAN CAMP' },
]

const eventsById = Object.fromEntries(events.map((e) => [e.id, e.name]))
const campsById  = Object.fromEntries(camps.map((c)  => [c.id, c.name]))

export function resolveIds(ids, map) {
  if (ids == null) return []
  const arr = Array.isArray(ids) ? ids : [ids]
  return arr.map((id) => map[id] ?? `#${id}`)
}

export { eventsById, campsById }
